<template>
  <div class="navbar">
    <el-row class="content-container">
      <el-col :span="8">
        <div style="float:left;overflow:hidden;height:60px;">
          <img
            src="@/assets/user_images/jdLogo.png"
            alt=""
            class="nav-logo"
            height="40"
            style="position: relative;top:9px;height: 40px;"
          >
        </div>
      </el-col>
      <el-col
        :span="8"
        style="color:#fff"
      >"$nbsp;"</el-col>
      <el-col :span="8">
        <div class="right-menu">
          <div
            class="back"
            @click="handleBack"
          >
            返回
          </div>
          <!-- <div class="avatar-wrapper">
          </div>
          <el-dropdown @command="handleClick">
            <div class="el-dropdown-link">
              <img
                src="@/assets/user_images/默认头像@1x.png"
                class="user-img"
              >
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command='0'>
                个人中心
              </el-dropdown-item>
              <el-dropdown-item
                command='1'
                style="padding:0px;"
              >
                <div style="line-height:36px; width:100%;height:36px;padding:0 20px;">
                  退出
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown> -->
        </div>
      </el-col>
    </el-row>
  </div>
</template>
  <script>
export default {
  methods: {
    handleClick (command) {
      if (command == 0) {
        this.handleUserCenter()
      } else if (command == 1) {
        this.handleQuite()
      }
    },
    handleUserCenter () {
      this.$router.push("/userCenter")
      console.log("个人中心")
    },
    handleQuite () {
      console.log('退出')
    },
    //返回
    handleBack () {
      this.$router.push("/userCenter")
    }
  }
}
  </script>
  <style lang="scss" scoped>
.quit {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.85);
  cursor: pointer;
}

.quit:hover {
  color: #fff;
}

.el-dropdown-menu__item {
  height: 44px;
  color: rgba(0, 0, 0, 0.65);
}

.el-dropdown-menu__item--divided {
  border-top: none;
  margin-top: 0;
}

.navbar
  .right-menu
  .avatar-container
  .avatar-wrapper
  .el-icon-arrow-down[data-v-d16d6306] {
  top: 23px;
}

.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: #fff;
  color: #13c2c2;
}

.el-dropdown-menu {
  top: 48px !important;
  // left:224px !important;
}

.el-dropdown {
  color: #fff;
  margin-right: 56px;
  font-size: 14px;
}

.el-popper .popper__arrow {
  display: none !important;
}

.logo {
  margin-left: 24px;
  margin-top: 5px;
}

.name {
  font-size: 12px;
  color: #fff;
  margin-right: 8px;
}

.user-img {
  top: 10px;
  position: relative;
}

.border {
  display: inline-block;
  border: 1px solid rgba(255, 255, 255, 0.5);
  height: 24px;
  position: relative;
  margin-right: 8px;
  margin-left: 8px;
  top: -2px;
}

.title {
  font-size: 16px;
  color: #fff;
  margin-right: 80px;
}

.navbar {
  height: 60px;
  overflow: hidden;
  position: relative;
  // background: #1c2b36;
  // box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          // width: 40px;
          // height: 40px;
          position: relative;
          top: 6px;
          border-radius: 10px;
        }

        .el-icon-arrow-down {
          cursor: pointer;
          position: absolute;
          right: -9px;
          top: 23px;
          font-size: 12px;
        }
      }
    }
  }
}

body .app-wrapper-new-style .navbar {
  height: 60px;
  box-sizing: border-box;
  padding: 0px 24px;
  line-height: 60px;
}

.el-menu.el-menu--horizontal {
  float: left;
}

.el-menu {
  background-color: #ffa940;
}

body .el-menu {
  top: 0px !important;
}
.items {
  line-height: 60px;
  font-size: 14px;
}
.items:hover {
  color: #13c2c2;
}
.back {
  color: #13c2c2;
  cursor: pointer;
  line-height: 60px;
  font-size: 14px;
}
</style>
